import { storage } from '@/utils/utils';
import { locale } from 'moment';
import { useMemo } from 'react';
import { useDispatch, useHistory, useIntl, useLocation } from 'umi';
import {
  OPINION_GUIDE_BOX_LIST1,
  OPINION_GUIDE_BOX_LIST2,
  OPINION_GUIDE_BOX_LIST3,
  OPINION_GUIDE_BOX_LIST4,
  OPINION_GUIDE_BOX_LIST5,
  OPINION_GUIDE_BOX_LIST6,
  OPINION_GUIDE_BOX_LIST1_PATH,
  OPINION_GUIDE_BOX_LIST2_PATH,
  OPINION_GUIDE_BOX_LIST3_PATH,
  OPINION_GUIDE_BOX_LIST4_PATH,
  OPINION_GUIDE_BOX_LIST5_PATH,
  OPINION_GUIDE_BOX_LIST6_PATH,
} from '.';

export default function useOpinionGuideData({
  userInfo,
  gameInfo,
  guidePermissions,
}: any) {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const location = useLocation();
  const history = useHistory();
  const { pathname } = location;
  // 模拟guide数据
  const GuideData = useMemo(() => {
    const { openid = '' } = userInfo || {};
    const list1 = storage.getLocalStorageItem(OPINION_GUIDE_BOX_LIST1);
    const list2 = storage.getLocalStorageItem(OPINION_GUIDE_BOX_LIST2);
    const list3 = storage.getLocalStorageItem(OPINION_GUIDE_BOX_LIST3);
    const list4 = storage.getLocalStorageItem(OPINION_GUIDE_BOX_LIST4);
    const list5 = storage.getLocalStorageItem(OPINION_GUIDE_BOX_LIST5);
    const list6 = storage.getLocalStorageItem(OPINION_GUIDE_BOX_LIST6);

    let blockList = [
      {
        id: 'overview',
        tit: formatMessage({ id: 'Overview of Opinions Data and Hot Topics' }),
        des: formatMessage({
          id: 'Analyzes Opinions data using multivariate analysis, including mentions, sentiment, topics, channels, location, and language',
        }),
        checked: (list1 || []).includes(openid),
        onClick: () => {
          dispatch({
            type: 'guide/showOpinionGuideOverview',
          });
          if (pathname !== OPINION_GUIDE_BOX_LIST1_PATH) {
            history.push(OPINION_GUIDE_BOX_LIST1_PATH);
          }
        },
      },
      {
        id: 'feeds',
        tit: formatMessage({
          id: 'Details of Overseas All-Channel Opinions Feeds',
        }),
        des: formatMessage({
          id: 'Real-time monitoring of worldwide social media, game stores, and news media',
        }),
        checked: (list2 || []).includes(openid),
        onClick: () => {
          dispatch({
            type: 'guide/showOpinionGuideFeeds',
          });
          if (pathname !== OPINION_GUIDE_BOX_LIST2_PATH) {
            history.push(OPINION_GUIDE_BOX_LIST2_PATH);
          }
        },
      },
      {
        id: 'gameStore',
        tit: formatMessage({
          id: 'Real-Time Ratings Across Global Game Stores',
        }),
        des: formatMessage({
          id: 'Provides insights into overall game ratings and changes in game stores worldwide',
        }),
        checked: (list3 || []).includes(openid),
        onClick: () => {
          dispatch({
            type: 'guide/showOpinionGuideGameStore',
          });
          if (pathname !== OPINION_GUIDE_BOX_LIST3_PATH) {
            history.push(OPINION_GUIDE_BOX_LIST3_PATH);
          }
        },
      },
      {
        id: 'community',
        tit: formatMessage({
          id: 'Community Performance Monitoring: Video, Streaming, and Influencers',
        }),
        des: formatMessage({
          id: 'Global official channel monitoring for real-time performance of content and accounts',
        }),
        checked: (list4 || []).includes(openid),
        onClick: () => {
          dispatch({
            type: 'guide/showOpinionGuideCommunity',
          });
          if (pathname !== OPINION_GUIDE_BOX_LIST4_PATH) {
            history.push(OPINION_GUIDE_BOX_LIST4_PATH);
          }
        },
      },
      {
        id: 'competitor',
        tit: formatMessage({
          id: 'Competitor Information and Comparison',
        }),
        des: formatMessage({
          id: 'Compares data indicators and opinion trends of your game with competitors',
        }),
        checked: (list5 || []).includes(openid),
        onClick: () => {
          dispatch({
            type: 'guide/showOpinionGuideCompetitor',
          });
          if (pathname !== OPINION_GUIDE_BOX_LIST5_PATH) {
            history.push(OPINION_GUIDE_BOX_LIST5_PATH);
          }
        },
      },
      {
        id: 'dataSource',
        tit: formatMessage({
          id: 'Data Source and Metrics',
        }),
        des: formatMessage({
          id: 'Introduces essential knowledge of Opinions, including data sources, terms, metrics, and calculations',
        }),
        checked: (list6 || []).includes(openid),
        onClick: () => {
          dispatch({
            type: 'guide/showOpinionGuideDataSource',
          });
          if (pathname !== OPINION_GUIDE_BOX_LIST6_PATH) {
            history.push(OPINION_GUIDE_BOX_LIST6_PATH);
          }
        },
      },
    ];

    if (gameInfo?.entity_type !== 'mobile') {
      blockList = blockList.filter((item) => item.id !== 'gameStore');
    }

    if (guidePermissions.length > 0) {
      blockList = blockList.filter(
        (item) => !guidePermissions.includes(item.id),
      );
    }

    return {
      mainTitle: formatMessage({ id: 'Opinions Introduction' }),
      mainDes: formatMessage({
        id: 'Stay on top of the latest trends across the global web, alerting users to potential risks and safeguarding game reputation.',
      }),
      blockTitle: formatMessage({ id: 'Tutorial-Core Functionality Display' }),
      blockList,
    };
  }, [formatMessage, userInfo, location, guidePermissions]);

  return {
    GuideData,
  };
}
